import { render, staticRenderFns } from "./CustomerExtrasList.vue?vue&type=template&id=455d3448&"
import script from "./CustomerExtrasList.vue?vue&type=script&lang=js&"
export * from "./CustomerExtrasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports